<!--suppress JSUnresolvedReference -->
<template>
  <div
    id="selectedServices"
    :class="{
      'p-top-0 m-mobile-view': true,
      'ibox-content': !service.viewPage && from !== 'inquiry',
    }"
    style="border: none"
  >
    <confirmation-popup
      :id="`confirmationDialog-${serviceWithClone}`"
      @on-confirm="removeService"
      message="Are you sure you want to delete this service?"
      title="Warning"
    ></confirmation-popup>

    <div :id="'service_checked_' + serviceWithClone" class="ibox">
      <div class="ibox-title service_auto_generate_title">
        <div class="inline-block">
          <div class="drag-tool">
            
            <span
              :id="service.service_name"
              style="margin-left: 3px"
              v-html="service.service_name"
            >
            </span>
            <br />
            <span class="category_name" style="margin-left:3px" v-html="service.category_name"> </span>
          </div>
        </div>

        <div class="inline float-right">
          <div
            :id="`service-${serviceWithClone}-dropdown`"
            class="dropdown inline m-right-20"
          >
            <div
              :data-target="`#service-${serviceWithClone}-dropdown`"
              aria-expanded="false"
              aria-haspopup="true"
              class="three_dots_style btn"
              data-toggle="dropdown"
            >
              <i class="fa fa-ellipsis-v ellipsis-v"></i>
            </div>
            <ul
              aria-labelledby="dLabel"
              class="dropdown-menu dropdown-menu-right"
            >
              <li>
                <!--:TODO add replicate function -->
                <a href="javascript:" @click="replicateService">Replicate</a>
              </li>
              <li>
                <!--:TODO add remove function -->
                <a
                  :data-target="`#confirmationDialog-${serviceWithClone}`"
                  data-toggle="modal"
                  href="javascript:"
                >
                  Delete
                </a>
              </li>
            </ul>
          </div>

          <!-- :TODO check hideShowTimeSummery will work fine when add appointments to the component!  -->
          <div class="inline" v-if="service.clone != '0'">
            <input
              type="hidden"
              name="services[]"
              :value="`${service.service_id + '_' + service.clone}`"
            />
            <input
              type="hidden"
              :id="`contractor_ids_${service.service_id + '_' + service.clone}`"
              :value="
                loggedUser.role_name == 'contractor' ? loggedUser.user_id : 0
              "
            />
            <input
              type="hidden"
              class="service_ids"
              :value="`${service.service_id + '_' + service.clone}`"
            />
            <a
              :aria-controls="
                'second_section_' + service.service_id + '_' + service.clone
              "
              aria-expanded="true"
              class="rotate"
              role="button"
              @click="toggleSummary"
            >
              <i
                :id="
                  'hideShowSummeryBtn_' +
                  service.service_id +
                  '_' +
                  service.clone
                "
                ref="toggleIcon"
                class="fa fa-chevron-down serviceCollapse"
              ></i>
            </a>
          </div>
          <div class="inline" v-else>
            <input
              type="hidden"
              name="services[]"
              :value="`${service.service_id}`"
            />
            <input
              type="hidden"
              :id="`contractor_ids_${service.service_id}`"
              :value="
                loggedUser.role_name == 'contractor' ? loggedUser.user_id : 0
              "
            />
            <input
              type="hidden"
              class="service_ids"
              :value="`${service.service_id}`"
            />
            <a
              :aria-controls="'second_section_' + service.service_id"
              aria-expanded="true"
              class="rotate"
              role="button"
              @click="toggleSummary"
            >
              <i
                :id="'hideShowSummeryBtn_' + service.service_id"
                ref="toggleIcon"
                class="fa fa-chevron-down serviceCollapse"
              ></i>
            </a>
          </div>
        </div>

        <div class="clearfix"></div>

        <div
          v-show="service.collapsed"
          :data-target="'#' + id"
          class="row mt-3"
          @click="toggleSummary('summary_schedule_visit_date')"
        >
          <custom-field-summary
            :service="service"
            :currency="currency"
            :unit="unitAttribute"
          ></custom-field-summary>

          <appointments-summary
            v-if="
              showServicePricing &&
              service.for_products !== 1 &&
              from !== 'inquiry'
            "
            :service="service"
            :hasDate="isBookingStatuesHasDate"
          ></appointments-summary>

          <products-summary :products="products"></products-summary>

          <!--                    <div class="col-md-12 col-xs-11 text-right schedule-header-title visit-header-date">-->
          <!--                        <div class="inline schedule-date general-sub-total-position fs-13" v-if="from !== 'inquiry'">-->
          <!--                            <b>-->
          <!--                                Sub total {{ currency.currency_symbol }}-->
          <!--                                {{ (service.pricing || {}).subTotalAfterDiscount }}-->
          <!--                            </b>-->
          <!--                        </div>-->
          <!--                    </div>-->
        </div>
      </div>

      <div
        v-show="!service.collapsed"
        :id="id"
        :aria-controls="id"
        class="ibox-content p-all-0 second-section"
      >
        <attributes
          v-model="service.attributes"
          :attributes="service.attributes"
          :service="service"
          :currency="currency"
          :date-format="dateFormat"
          :time-format="timeFormat"
          :unit="unitAttribute"
          :item-id="itemId"
          class="custom-field"
        >
        </attributes>

        <hr v-if="from !== 'inquiry'" />

        <add-product
          v-if="from !== 'inquiry'"
          v-model="products"
          :currency="currency"
          :service="service"
          :auto-assigned="autoAssigned"
          :service-booking-products="serviceBookingProducts"
          :itemid="service.itemId"
          :class="[
            { 'new-products': true, 'p-bottom-8': service.for_products === 1 },
          ]"
        ></add-product>

        <hr v-if="from !== 'inquiry'" />

        <Appointments
          v-if="
            showServicePricing &&
            service.for_products !== 1 &&
            from !== 'inquiry'
          "
          :displayCopyDates="displayCopyDates"
          :logged-user="loggedUser"
          v-model="service.visits"
          :service="service"
          :item-type="itemType"
          :item-id="itemId"
          :bookingStatuses="bookingStatuses"
          @appointmentsMounted="onAppointmentsMounted"
          :duplicate="duplicate"
          :hasDate="isBookingStatuesHasDate"
        ></Appointments>

        <!--                <service-pricing v-if="showServicePricing && from !== 'inquiry'"-->
        <!--                                 v-model="service.pricing"-->
        <!--                                 :company-id="companyId"-->
        <!--                                 :item-id="service.itemId"-->
        <!--                                 :item-type="itemType"-->
        <!--                                 :currency="currency"-->
        <!--                                 :logged-user="loggedUser"-->
        <!--                                 :products="products"-->
        <!--                                 :service="service"-->
        <!--                                 class="service-billing"-->
        <!--                ></service-pricing>-->
      </div>
      <input
        type="hidden"
        id="deleted_appointments"
        :name="`deleted_appointments_${service.service_id}_${service.clone}`"
        v-model="deletedAppointmentsString"
      />
      <confirmation-popup
        title="Warning"
        message="Are you sure you want to delete this Appointment?"
        :id="confirmationDialogId"
        @on-confirm="onSelectedVisitDeleteConfirm"
      ></confirmation-popup>
    </div>

    <service-pricing
      v-if="showServicePricing"
      v-model="service.pricing"
      :company-id="companyId"
      :from="from"
      :item-id="service.itemId"
      :item-type="itemType"
      :currency="currency"
      :logged-user="loggedUser"
      :products="products"
      :service="service"
      class="service-billing"
    ></service-pricing>
  </div>
</template>

<script>
import { EventBus } from "@/events/event-bus";
import _ from "lodash";

// Reserved Attribute IDs
const QUANTITY = 15;
const PRICE = 16;
const UNIT = 17;
const DISCOUNT = 19;
const TAX_RATE = 61;
const DESCRIPTION = 46;
const EXTRA_CHARGE = 2359;
const SERVICE_DISCOUNT = 2360;
const SERVICE_DISCOUNT_TYPE = 2361;

export default {
  name: "service",
  props: {
    value: {
      required: true,
    },
    currency: {
      required: true,
    },
    loggedUser: {
      required: true,
    },
    companyId: {
      required: true,
    },
    dateFormat: {
      required: true,
    },
    timeFormat: {
      required: true,
    },
    itemType: {
      required: true,
    },
    from: String,
    itemId: {},
    duplicate: {
      default() {
        return false;
      },
    },
    displayCopyDates: {},
    bookingStatus: {},
    taxRatesOptions: [],
    bookingStatuses: {
      type: Array,
    },
  },
  computed: {
    unitAttribute() {
      if ( this?.service?.attributes){
        return this.service.attributes.find((attribute) =>
            this.isUnit(attribute)
        );
      }else {
        return null
      }

    },
    isBookingStatuesHasDate() {
      return (this.bookingStatus || {}).has_date ||
        +(this.service.meta && this.service.meta.toEstimate)
        ? true
        : false;
    },
    /**
     * @returns {string}
     */
    id() {
      if (parseInt(this.service.clone)) {
        return `second_section_${this.service.service_id}_${this.service.clone}`;
      }
      return `second_section_${this.service.service_id}`;
    },
    serviceWithClone() {
      if (parseInt(this.service.clone)) {
        return `${this.service.service_id}_${this.service.clone}`;
      }
      return `${this.service.service_id}`;
    },
    deletedAppointmentsString: {
      get() {
        return this.deletedAppointments.join(",");
      },
      set(value) {
        this.deletedAppointments = value.split(",").map(Number); // Convert back to array of numbers
      },
    },
  },
  data() {
    return {
      service: this.value,
      reserved: [
        QUANTITY,
        PRICE,
        UNIT,
        DISCOUNT,
        DESCRIPTION,
        EXTRA_CHARGE,
        SERVICE_DISCOUNT,
        SERVICE_DISCOUNT_TYPE,
      ],
      booking: {
        status: null,
      },
      products: (this.value.products || {}).serviceBookingProducts ?? [],
      autoAssigned:
        this.value.itemId === null ||
        this.itemType === "inquiry" ||
        (this.value.meta && this.value.meta.toEstimate)
          ? this.value.auto_assigned_products
          : [],
      serviceBookingProducts: this.value.serviceBookingProducts ?? [],
      showServicePricing:
        this.value.itemId === null ||
        this.itemType === "inquiry" ||
        (this.value.meta && this.value.meta.toEstimate),
      showAppointment:
        this.value.itemId === null || this.itemType === "inquiry",
      confirmationDialogId: `appointment-confirmation${
        this.value.service_id + this.value.clone
      }`,
      deletedAppointments: [],
    };
  },
  methods: {
    onAppointmentsMounted() {
      // This function will be called when the visited component is mounted
      this.$emit("serviceMounted");
    },
    isDependent(attribute) {
      return attribute.is_dependent;
    },
    isHidden(attribute) {
      return attribute.is_hidden;
    },
    isDeleted(attribute) {
      return attribute.is_deleted;
    },
    isReserved(attribute) {
      return this.reserved.includes(attribute.attribute_id);
    },
    isMandatory(attribute) {
      return ["Description", "Service Manual"].includes(
        attribute.attribute_name
      );
    },
    isAvailable(attribute) {
      return !this.isHidden(attribute) && !this.isDeleted(attribute);
    },
    isQuantity(attribute) {
      return attribute.attribute_id === QUANTITY;
    },
    isPrice(attribute) {
      return attribute.attribute_id === PRICE;
    },
    isDiscount(attribute) {
      return attribute.attribute_id === SERVICE_DISCOUNT;
    },
    isDiscountType(attribute) {
      return attribute.attribute_id === SERVICE_DISCOUNT_TYPE;
    },
    isExtraCharge(attribute) {
      return attribute.attribute_id === EXTRA_CHARGE;
    },
    isTaxRate(attribute) {
      return attribute.attribute_id === TAX_RATE;
    },
    isUnit(attribute) {
      return attribute.attribute_id === UNIT;
    },
    attributesSortHandler(current, next) {
      if (current.attribute_name.charAt(0) < next.attribute_name.charAt(0)) {
        return -1;
      } else if (
        current.attribute_name.charAt(0) > next.attribute_name.charAt(0)
      ) {
        return 1;
      }
      return 0;
    },
    sortMandatoryHandler(current, next) {
      if (["Description", "Service Manual"].includes(current.attribute_name)) {
        return 1;
      } else {
        return -1;
      }
    },
    removeService() {
      EventBus.$emit(
        "onServiceRemoved1",
        this.service.service_id,
        this.service.clone
      );
    },
    addEventListeners() {
      EventBus.$on("visitDeleted", (index, serviceId, clone) => {
        if (
          this.service.service_id === serviceId &&
          this.service.clone === clone
        ) {
          $(`#${this.confirmationDialogId}`).modal("show");
          this.toBeDeltedVisitIndex = index;
        }
      });
    },
    onSelectedVisitDeleteConfirm() {
      let visitToBeDeleted = this.service.visits.splice(
        this.toBeDeltedVisitIndex,
        1
      );
      if (visitToBeDeleted[0].hasOwnProperty("id")) {
        this.deletedAppointments.push(visitToBeDeleted[0].multiple_day_id);
        EventBus.$emit("serviceChanged", this.deletedAppointments);
      }

      this.$nextTick(() => {
        EventBus.$emit("onAddDeleteAppointment");
      });
    },
    replicateService() {
      let service = _.cloneDeep(this.service);

      service.serviceId = service.service_id;
      if (service.visits) {
        service.visits.forEach((visit) => (visit.id = 0));
      }
      EventBus.$emit("onServiceDuplicated", service);
    },
    toggleSummary(target) {
      this.service.collapsed = !this.service.collapsed;
      this.$forceUpdate();
      $(this.$refs.toggleIcon).toggleClass("rotate-180");

      EventBus.$emit(
        "collapseExpandServicePricing",
        this.service.service_id,
        this.service.clone,
        this.service.collapsed
      );

      if (target && !this.service.collapsed) {
      } else {
        this.service.dontexpand = 1;
        EventBus.$emit("onCollapseService", this.service);
      }
    },
  },
  mounted() {
    this.addEventListeners();
    // Ensure that the ServicePricing component renders
    // after the Service component and its child components have mounted.
    this.$nextTick(() => {
      this.showServicePricing = true;
      if (this?.service?.taxRatesOptions){
        this.service.taxRatesOptions = this.taxRatesOptions;
      }
    });
  },
  watch: {
    service: {
      handler: function (service) {
        if (!this.service.from_controller) {
          this.$emit("input", service);
        } else {
          this.service.from_controller = true;
        }
      },
      deep: true,
    },
    products: {
      handler: function (products) {
        this.service.products = products;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.service_auto_generate_title {
  padding-bottom: 0px;
}

:deep(.modal-footer) {
  display: block !important;
}

.service-billing {
  margin-top: -20px;
}

.m-right-20 {
  margin-right: 10px;
}

.ellipsis-v {
  color: #2e4051;
  font-size: 18px;
}

.serviceCollapse {
  color: #2e4051;
}

.second-section {
  background-color: #f5f5f6;
  //border-radius: 8px; border-width: 0px 0px;
}

.fs-13 {
  font-size: 13px;
}

@media (max-width: 768px) {
  .m-mobile-view {
    margin: 8px -12px 0 -12px;
  }
}
</style>
